<template>
  <div class="wrapper" style="background:white;">
  <div class="search-header">
    <div class="search-header-text">推送结果</div>
  </div>
  <div class="Push-article-setting">
    重大事件
  </div>
  <div class="Push-article-box" >

    <div class="Push-article-list" v-for="(index,item) in eventMessage">
      <div class="head-title" @click="view(item), setCnzz('我的订阅', '查看公告', '')" style="font-size:0.8rem;">
       {{item.title}}
       </div>
       <div class="head-industry">
          <span class="head-time-category head-category-b" v-for="i in item.labels">{{i}}</span>
      </div>
      <div class="head-time"><span class="head-time-fl" v-if="item.companyCode">证券代码：{{item.companyCode}}</span> <span class="head-time-fr">{{item.publishDate}}</span></div>
      <div class="Related-announ" v-if="item.childcnt && item.childcnt > 0" @click.stop="getRelation(index)">
        <h3>
          相关公告({{item.childcnt}})
          <span class="release-open" v-if="!item.showrelationnotice"></span>
          <span class="release-close" v-if="item.showrelationnotice"></span>
        </h3>
        <ul v-if="item.showrelationnotice && item.relationItems && item.relationItems.length > 0">
          <li v-for="z in item.relationItems" @click.stop="view(z)">
            {{z.title}}
            <span class="head-time-fr">{{z.publishDate}}</span>
          </li>
        </ul>
        <ul v-if="item.showrelationnotice && item.relationItems && item.relationItems.length === 0">
          <li style="text-align:center;color: silver;">
            无公告数据
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="ubscribe-news-no" v-if="loading == 1">
    <div class="ubscribe-news-no-cont">
     <img src="../../static/images/loading2.gif">
     </div>
  </div>
  <div class="ubscribe-news-no" v-if="loading == 2">
    已全部加载
  </div>
  <div class="ubscribe-news-no" v-if="loading == 3">
    暂无消息
  </div>
  <!-- <div v-if="loading">正在加载中...</div> -->
  <!-- <div v-if="!loading">已全部加载</div> -->
</div>
</template>
<script>
import $ from 'jquery'
import {apiUrl, alert} from '../helper'
import userMix from '../common/userMix'
import searchMix from '../common/SearchMix'
import comsearchMix from '../common/comSearchMix'
import wxshareMix from '../common/wxshareMix'
export default {
  mixins: [userMix, searchMix, comsearchMix, wxshareMix],
  data () {
    return {
      eventId: '',
      page: 0,
      totalPage: 0,
      eventMessage: [],
      stype: 1,
      loading: 1,
      sendagain: true
    }
  },
  ready () {
    $(document).bind('scroll', this.scrollEvent)
  },
  route: {
    data ({ to }) {
      // this.getProfile('weixin')
      // 初始化
      this.eventId = ''
      this.page = 0
      this.totalPage = 0
      this.eventMessage = []
      this.stype = 1
      this.loading = 1
      this.sendagain = true

      document.title = '推送内容'
      if (!this.currentuser) {
        this.wxcode = this.getQueryString('code')  // 获取微信登录code
        if (this.wxcode) {
          this.wxlogin(this.wxcode)
        } else {
          this.getProfile('weixin')
        }
      }
      if (this.currentuser) {
        this.getProfile('weixin')
        if (this.currentuser.regtyp == 4 ) {
          // 绑定账号
          this.goBindPage(1)
          return false
        }
        if (this.currentuser.mp == 0 || !this.currentuser.weixin) {
          let appid = this.$config.weixin.appid
          this.currentuser = null
          let redirectUri = encodeURIComponent(window.location.href)
          window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + redirectUri + '&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect'

          return false
        }
        if (!this.checkPrivilege('user/event', '暂无权限')) {
          return false
        }
        this.eventId = to.params.id
        console.log(this.eventId)
        this.getMsg()
        // this.getStype()
      }
    }
  },
  methods: {
    setCnzz (name, action, label) {
      window._czc.push(['_trackEvent', name, action, label])
      console.log(name + ' : ' + action + ' : ' + label)
    },
    scrollEvent: function () {
      if (($(window).scrollTop() + $(window).height()) >= $(document).height()) {
        // this.page = this.page + 1
        this.getMsg()
      }

    },
    // getStype: function () {
    //   $.ajax({
    //     url: apiUrl('/V1.0.0/user/eventlist'),
    //     method: 'post',
    //     dataType: 'json'
    //   }).done((response) => {
    //     if (response.status == 0) {
    //       let arr = response.data
    //       for (let i of arr) {
    //         if (i.id == this.eventId) {
    //           this.stype = i.stype
    //           break
    //         }
    //       }

    //     } else {
    //       alert(response.description)
    //     }
    //   }).fail((response) => {
    //     alert('请求失败')
    //   })
    // },
    getMsg: function () {
      if (!this.sendagain) {
        return false
      }
      this.sendagain = false
      this.page = this.page + 1
      var query = {'msgid': this.eventId, 'page': this.page, 'perPage': 10}
      $.ajax({
        url: apiUrl('/V1.0.0/notice/searchevent'),
        method: 'post',
        dataType: 'json',
        data: JSON.stringify(query)
      }).done((response) => {
        this.sendagain = true
        if (response.status == 0) {
          this.stype = response.event.stype
          this.totalPage = Math.ceil(response.total / 10)

          for (let i of response.lists) {
            this.eventMessage.push(i)
          }
          if (this.eventMessage.length == 0) {
            this.loading = 3
            $(document).unbind('scroll')
            return false
          }
          if (this.eventMessage.length == response.total) {
            this.loading = 2
            $(document).unbind('scroll')
            return false
          }
          // this.eventMessage = response.lists
        } else {
          alert(response.description)
        }
      }).fail((response) => {
        this.sendagain = true
        alert('请求失败')
      })
    },
    getRelation: function (index) {
      // console.log('getRelation')
      if (this.eventMessage[index].relationItems) {
        this.eventMessage[index].showrelationnotice = !this.eventMessage[index].showrelationnotice
      } else {
        this.showRelation(index)
      }
    },
    showRelation: function (index) {
      let requrl = apiUrl('/V1.0.0/notice/relationnotice')
      let query = {'id': this.eventMessage[index].id, 'pid': this.eventMessage[index].pid, 'stype': this.stype}
      $.ajax({
        url: requrl,
        method: 'post',
        dataType: 'json',
        data: JSON.stringify(query)
      }).done((response) => {
        if (response.status === 0) {
          // this.$set(this.eventMessage[index], 'showrelationnotice', true)
          // this.$set(this.eventMessage[index], 'relationItems', [])
          let tmp = $.extend(true, [], this.eventMessage)
          tmp[index].showrelationnotice = true
          tmp[index].relationItems = []
          let items = response.data.lists
          for (let d of items) {
            if (d.id !== tmp[index].id) {
              tmp[index].relationItems.push(d)
            }
          }
          this.eventMessage = tmp
          console.log('test')
        } else if (response.status === 502) {
          alert('很抱歉，请求超时请重新搜索')
        }
      }).fail((response) => {
        alert('请求失败')
      })
    },
    view: function (item) {
      var url = this.viewUrl(item)
      window.location.href = url
    },
    viewUrl: function (item) {
      if (item.viewtype === 1) {
        let tcode = ''
        if (item.pid) {
          return '/#!/notice-detail/' + item.id + '?pid=' + item.pid + '&stype=' + this.stype + '&pdate=' + item.publishDate + '&idxname='
        } else {
          return '/#!/notice-detail/' + item.id + '?stype=' + this.stype + '&pdate=' + item.publishDate + '&idxname='
        }
      }
      if (item.viewtype === 2) {
        return item.sourceurl
      }
      if (item.viewtype === 3) {
        return item.downloadurl
      }
    }
  }
}
</script>



/** WEBPACK FOOTER **
 ** eventMessage.vue?a6511ef2
 **/